import {Store,Module,ActionContext} from 'vuex'
import ListModule from '../list-module'
import ListState from '../list-state'
import Branch from '../../entities/admin/branch'
import Ajax from '../../../lib/ajax' 
import Util from '../../../lib/util'

interface BranchState extends ListState<Branch>{
    editModel:Branch;
    
}
class BranchModule extends ListModule<BranchState,any,Branch>{
    state={
        totalCount:0,
        currentPage:1,
        pageSize: 10,
        list: new Array<Branch>(),
        loading:false,
        editModel: new Branch(),
        activeList: new Array<Branch>(),
        path: 'dealer-branches'          
    }
    actions = Util.extend(true, this.base_actions, {
        //extra actions        
    });
    mutations = Util.extend(true, this.base_mutations, {
        //extra mutations
    });
}
const branchModule=new BranchModule();
export default branchModule;
